import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'
import search from '@/views/search/index'
import store from '@/views/store/index'
import category from '@/views/category/index'
import evaluate from '@/views/evaluate/index'
import index from '@/views/home/index'
import login from '../views/login/login'
import settled from '../views/settled/settled'
import orderDetail from '../views/orderDetail/index'
import shoppingTrolley from '../views/shopping-trolley/index'
import productDetail from '../views/product/productDetail'
import placeOrder from '../views/placeOrder/index'
import afterSale from '../views/afterSale/index'
import addEvaluate from '../views/addEvaluate/index'
import evaluateDetail from '../views/evaluateDetail/index'
import couponProList from '../views/couponProlist/index'
import about from '@/views/us/about.vue'
import storelist from '@/views/us/storelist'
import realize from '@/views/us/realize.vue'
import collaborate from '@/views/us/collaborate.vue'
import contact from '@/views/us/contact.vue'
// 用户中心中心
import userCenter from '../views/userCenter/userCenter'
import couponPackage from '../views/userCenter/couponPackage/couponPackage'
import myOrder from '../views/userCenter/myOrder/myOrder'
import signingAddress from '../views/userCenter/signingAddress/signingAddress'
import userInfo from '../views/userCenter/userInfo/userInfo'
import orderAfterSale from '../views/userCenter/orderAfterSale/orderAfterSale'
import changePhone from '../views/userCenter/changeInfo/changePhone'
import invoiceInfo from '../views/userCenter/invoice/invoiceInfo'
import receiveCoupon from '../views/userCenter/receiveCoupon/receiveCoupon'
import myCollect from '../views/userCenter/myCollect/myCollect'
import myEvaluate from '../views/userCenter/myEvaluate/index'
import categoryProduct from '../views/categoryProduct/index'
import maybeLike from '../views/userCenter/maybeLike/maybeLike'
import  foot from  '../views/userCenter/foot/foot'
import  message from  '../views/userCenter/message/message';
// import changePwd from '../views/userCenter/changeInfo/changePwd'
// import unbindPhone from '../views/userCenter/changeInfo/unbindPhone'

// const error = (resolve) => {
//   import('@/components/error/error').then((module) => {
//     resolve(module)
//   })
// }
Vue.use(Router)

const router = new Router({
  routes: [

    {
      path: '/',
      name: 'layout',
      component: layout,
      redirect: { name: 'index' },
      children: [
        // 首页
        {
          path: '/index',
          name: 'index',
          component: index,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
		// 关于我们
		{
		  path: '/about',
		  name: 'about',
		  component: about,
		  meta: {
			logoText: '',
			searchVisible: true
		  }
		},
		// 了解我们
		{
		  path: '/realize',
		  name: 'realize',
		  component: realize,
		  meta: {
			logoText: '',
			searchVisible: true
		  }
		},
		// 合作咨询
		{
		  path: '/collaborate',
		  name: 'collaborate',
		  component: collaborate,
		  meta: {
			logoText: '',
			searchVisible: true
		  }
		},
		// 联系我们
		{
		  path: '/contact',
		  name: 'contact',
		  component: contact,
		  meta: {
			logoText: '',
			searchVisible: true
		  }
		},
// 商家列表
        {
          path: '/storelist',
          name: 'storelist',
          component: storelist,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 用户中心
        {
          path: '/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            logoText: '',
            searchVisible: false
          },
          children: [
            {
              path: '/couponPackage',
              name: 'couponPackage',
              component: couponPackage,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myOrder',
              name: 'myOrder',
              component: myOrder,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/orderAfterSale',
              name: 'orderAfterSale',
              component: orderAfterSale,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/signingAddress',
              name: 'signingAddress',
              component: signingAddress,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/userInfo',
              name: 'userInfo',
              component: userInfo,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/changePhone',
              name: 'changePhone',
              component: changePhone,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/invoiceInfo',
              name: 'invoiceInfo',
              component: invoiceInfo,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/foot',
              name: 'foot',
              component: foot,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myEvaluate',
              name: 'myEvaluate',
              component: myEvaluate,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/maybeLike',
              name: 'maybeLike',
              component: maybeLike,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/receiveCoupon',
              name: 'receiveCoupon',
              component: receiveCoupon,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myCollect',
              name: 'myCollect',
              component: myCollect,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/message',
              name: 'message',
              component: message,
              meta: {
                logoText: '',
                searchVisible: false
              }
            }
            // {
            //   path: '/changePwd',
            //   name: 'changePwd',
            //   component: changePwd,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // },
            // {
            //   path: '/unbindPhone',
            //   name: 'unbindPhone',
            //   component: unbindPhone,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // }
          ]
        },
        // 搜索
        {
          path: '/search',
          name: 'search',
          component: search,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 店铺主页
        {
          path: '/store',
          name: 'store',
          component: store,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 分类页面
        {
          path: '/category',
          name: 'category',
          component: category,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价
        {
          path: '/evaluate',
          name: 'evaluate',
          component: evaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 购物车
        {
          path: '/shopping-trolley',
          name: 'shoppingTrolley',
          component: shoppingTrolley,
          meta: {
            logoText: '',
            searchVisible: true
          }

        },
        // 订单详情
        {
          path: '/orderDetail',
          name: 'orderDetail',
          component: orderDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }

        },
        // 商品详情
        {
          path: '/productDetail',
          name: 'productDetail',
          component: productDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 下单页面
        {
          path: '/placeOrder',
          name: 'placeOrder',
          component: placeOrder,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/afterSale',
          name: 'afterSale',
          component: afterSale,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价详情
        {
          path: '/evaluateDetail',
          name: 'evaluateDetail',
          component: evaluateDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 追评
        {
          path: '/addEvaluate',
          name: 'addEvaluate',
          component: addEvaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 优惠券商品
        {
          path: '/couponProList',
          name: 'couponProList',
          component: couponProList,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 类别商品
        {
          path: '/categoryProduct',
          name: 'categoryProduct',
          component: categoryProduct,
          meta: {
            logoText: '',
            searchVisible: true
          }
        }
      ]
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: login
    },

    // 商家入驻
    {
      path: '/settled',
      name: 'settled',
      component: settled
    }

  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // cookie没有值就跳到登陆页
  // let area = sessionStorage.getItem('area')
  // if (area === null && to.name !== 'login' && to.name !== 'overview') {
  //   // Vue.prototype.$message.error('用户未登陆')
  //   next('/login')
  // } else {
  next()
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js